import React, { useState } from 'react';
import Button from '../common/Button';
import { theme } from '../../config/theme';

const CancelModal = ({ isOpen, onClose, onConfirm, loading }) => {
  const [reason, setReason] = useState('');
  const isValid = reason.trim().length >= 10;

  if (!isOpen) return null;

  const handleConfirm = () => {
    if (isValid) onConfirm(reason.trim());
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: theme.zIndex.modal,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      backgroundColor: 'rgba(0,0,0,0.5)',
    }}>
      <div style={{
        backgroundColor: theme.colors.white,
        borderRadius: theme.borderRadius.xl,
        padding: theme.spacing['2xl'],
        width: '100%', maxWidth: '480px',
        margin: theme.spacing.lg,
        display: 'flex', flexDirection: 'column', gap: theme.spacing.lg,
      }}>
        <div>
          <h2 style={{ fontSize: theme.typography.fontSize.xl, fontWeight: theme.typography.fontWeight.bold, marginBottom: theme.spacing.xs }}>
            Cancel Subscription
          </h2>
          <p style={{ fontSize: theme.typography.fontSize.sm, color: theme.colors.text.secondary }}>
            Your plan stays active until the end of the billing period. You'll revert to the Free tier after expiry.
          </p>
        </div>

        <div>
          <label style={{ display: 'block', fontSize: theme.typography.fontSize.sm, fontWeight: theme.typography.fontWeight.medium, marginBottom: theme.spacing.xs }}>
            Reason for cancelling <span style={{ color: theme.colors.error }}>*</span>
          </label>
          <textarea
            value={reason}
            onChange={e => setReason(e.target.value)}
            placeholder="Please tell us why you're cancelling (min. 10 characters)"
            rows={4}
            style={{
              width: '100%', resize: 'vertical',
              padding: theme.spacing.md,
              border: `1px solid ${theme.colors.border.main}`,
              borderRadius: theme.borderRadius.md,
              fontSize: theme.typography.fontSize.sm,
              fontFamily: 'inherit',
              outline: 'none',
              boxSizing: 'border-box',
            }}
          />
          <p style={{ fontSize: theme.typography.fontSize.xs, color: reason.length < 10 ? theme.colors.error : theme.colors.text.secondary, marginTop: theme.spacing.xs }}>
            {reason.length}/10 minimum characters
          </p>
        </div>

        <div style={{ display: 'flex', gap: theme.spacing.md }}>
          <Button variant="secondary" fullWidth onClick={onClose} disabled={loading}>
            Keep Plan
          </Button>
          <Button
            fullWidth
            disabled={!isValid || loading}
            loading={loading}
            onClick={handleConfirm}
            style={{ backgroundColor: theme.colors.error, borderColor: theme.colors.error }}
          >
            Confirm Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CancelModal;